import React from 'react'
import { NavLink } from 'react-router-dom'
import { Bars3Icon, BellIcon, Cog6ToothIcon, HomeIcon, UsersIcon } from "@heroicons/react/16/solid";
import { Bars4Icon } from "@heroicons/react/24/solid";

import { IoHomeOutline, IoSettingsOutline } from "react-icons/io5";
import { PiUsersThreeLight } from "react-icons/pi";
import { FaRegCalendarAlt, FaUniversity } from 'react-icons/fa';
import { FaQuestionCircle } from "react-icons/fa";
import { FaBuilding, FaBullseye } from 'react-icons/fa6';
import { ImUsers } from 'react-icons/im';

function Sidebar() {
    return (
        <>
            <aside className="pageSidebar w-[16.875rem] h-full shrink-0 bg-[#584475]">

                <div className="logo custFlex p-3 text-center text-white shadow-[0px_0px_28px_rgba(0,0,0,0.13)] h-[66px]">
                    <h4>Mandap Admin</h4>
                </div>

                {/* Menu */}
                <nav className="flex-1 overflow-auto my-3">
                    <ul className="space-y-1">

                        {/* Dashboard */}
                        <li>
                            <NavLink
                                to="/admin"
                                end
                                className={({ isActive }) =>
                                    `flex items-center gap-3 px-8 py-3 text-sm font-semibold  transition-all
    ${isActive
                                        ? "bg-[#0000001a] text-white font-semibold"
                                        : "text-[#876fab] hover:bg-[#0000001a] hover:text-white hover:font-semibold"
                                    }`
                                }
                            >
                                <IoHomeOutline className="text-lg" />
                                <span>Dashboard</span>
                            </NavLink>
                        </li>

                        {/* Users */}
                        <li>
                            <NavLink
                                to="/admin/users"
                                className={({ isActive }) =>
                                    `flex items-center gap-3 px-8 py-3 text-sm font-semibold  transition-all
    ${isActive
                                        ? "bg-[#0000001a] text-white font-semibold"
                                        : "text-[#876fab] hover:bg-[#0000001a] hover:text-white hover:font-semibold"
                                    }`
                                }
                            >

                                <ImUsers className="text-lg" />
                                <span>Users</span>
                            </NavLink>
                        </li>

                        {/* Bookings */}
                        <li>
                            <NavLink
                                to="/admin/bookings"
                                className={({ isActive }) =>
                                    `flex items-center gap-3 px-8 py-3 text-sm font-semibold  transition-all
    ${isActive
                                        ? "bg-[#0000001a] text-white font-semibold"
                                        : "text-[#876fab] hover:bg-[#0000001a] hover:text-white hover:font-semibold"
                                    }`
                                }
                            >

                                <FaRegCalendarAlt className="text-lg" />
                                <span>Bookings</span>
                            </NavLink>
                        </li>

                        {/* Faq */}

                        <li>
                            <NavLink
                                to="/admin/faq"
                                className={({ isActive }) =>
                                    `flex items-center gap-3 px-8 py-3 text-sm font-semibold transition-all
            ${isActive
                                        ? "bg-[#0000001a] text-white font-semibold"
                                        : "text-[#876fab] hover:bg-[#0000001a] hover:text-white hover:font-semibold"
                                    }`
                                }
                            >

                                <FaQuestionCircle className="text-lg" />

                                <span>FAQ</span>

                            </NavLink>
                        </li>

                        <li>
                            <NavLink
                                to="/admin/booking-account-info"
                                className={({ isActive }) =>
                                    `flex items-center gap-3 px-8 py-3 text-sm font-semibold transition-all
            ${isActive
                                        ? "bg-[#0000001a] text-white font-semibold"
                                        : "text-[#876fab] hover:bg-[#0000001a] hover:text-white hover:font-semibold"
                                    }`
                                }
                            >
                                <FaUniversity className="text-lg" />
                                <span>Account Info</span>
                            </NavLink>
                        </li>


                        {/* Pages */}
                        <li className="mt-6 text-xs font-semibold text-white/50 uppercase tracking-wider px-8 py-3 ">
                            Pages
                        </li>


                        {/* Settings */}
                        <li className="mt-6 text-xs font-semibold text-white/50 uppercase tracking-wider px-8 py-3 ">
                            Masters
                        </li>
                        <li>

                            <NavLink
                                to="/admin/mandaps"
                                className={({ isActive }) =>
                                    `flex items-center gap-3 px-8 py-3 text-sm font-semibold transition-all
            ${isActive
                                        ? "bg-[#0000001a] text-white font-semibold"
                                        : "text-[#876fab] hover:bg-[#0000001a] hover:text-white hover:font-semibold"
                                    }`
                                }
                            >

                                <FaBuilding className="text-lg" />

                                <span>
                                    Mandaps
                                </span>

                            </NavLink>

                        </li>
                        <li>

                            <NavLink
                                to="/admin/purposes"
                                className={({ isActive }) =>
                                    `flex items-center gap-3 px-8 py-3 text-sm font-semibold transition-all
            ${isActive
                                        ? "bg-[#0000001a] text-white font-semibold"
                                        : "text-[#876fab] hover:bg-[#0000001a] hover:text-white hover:font-semibold"
                                    }`
                                }
                            >

                                <FaBullseye className="text-lg" />

                                <span>
                                    Purposes
                                </span>

                            </NavLink>

                        </li>
                        <li>
                            <NavLink
                                to="/admin/settings"
                                className={({ isActive }) =>
                                    `flex items-center gap-3 px-8 py-3 text-sm font-semibold  transition-all
    ${isActive
                                        ? "bg-[#0000001a] text-white font-semibold"
                                        : "text-[#876fab] hover:bg-[#0000001a] hover:text-white hover:font-semibold"
                                    }`
                                }
                            >

                                <IoSettingsOutline className="h-5 w-5" />
                                <span>Settings</span>
                            </NavLink>
                        </li>

                    </ul>
                </nav>
            </aside>
        </>
    )
}

export default Sidebar